import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActionLinkComponent} from './action-link.component';



@NgModule({
  declarations: [
    ActionLinkComponent
  ],
    imports: [
        CommonModule,
    ],
  exports: [ActionLinkComponent]
})
export class ActionLinkModule { }
